module.exports = __webpack_public_path__ + "static/article-3-8dc0bd9aa261f196bf7cc6db91fb8a92.jpg";